import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import "./../../View.css";
import "./../../Grid.css";
import "./../../Form.css";
import "./../../App.css";
import "./Workplace.css";
import WorkplaceSearchForm from './WorkplaceSearchForm';
import SearchView from "../../widgets/SearchView";
import ViewUtils from '../../ViewUtils';
import { ViewContainer } from "./../../View.jsx";
import withMenuPermission from "../../widgets/withMenuPermission";


const utils = new ViewUtils();

const headCells = [
    { id: 'CompanyName', numeric: true, disablePadding: false, label: 'Company Name', widthRatio: .5 },
    { id: 'Industry', numeric: false, disablePadding: false, label: 'Industry', widthRatio: .25 },
    {
        id: 'ContactPerson', numeric: false, disablePadding: false, label: 'Contact Person', widthRatio: .25,
    }
];



const filterParameters = [
    { dataField: "CompanyName", text: "CompanyName" },
]

class WorkplaceSearch extends Component {

    constructor(props) {
        super(props)
        this.state = {
            model: {
                CompanyName: ""
            },
            parameters: {},
            keyUpSwitch: false,
            selectedWorkplace: null
        };

        this.toolbarConfig = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        /*{ id: 'view', label: '', tooltip: 'View', icon: 'ViewIcon', visible: this.props.menuPermissionItem.View },*/
                        { id: 'add', label: '', tooltip: 'Add', icon: 'AddIcon', visible: this.props.menuPermissionItem.Add},
                        { id: 'edit', label: '', tooltip: 'Edit', icon: 'EditIcon', disabled: true, visible: this.props.menuPermissionItem.Edit},
                        { id: 'delete', label: '', tooltip: 'Delete Workplace', icon: 'DeleteIcon', disabled: true, visible: this.props.menuPermissionItem.Delete}
                    ]
                }
            ]
        };

        this.searchParameters = this.searchParameters = !utils.isNull(this.props.programmeId) ?

            [
                { Name: "id", Value: this.props.programmeId },
                { Name: "CompanyName", Value: "" }
            ]
            :
            [
                { Name: "CompanyName", Value: "" },
            ]
    }

    onkeyup(e) {
        if (e.charCode == 13) {
            this.setState({ keyUpSwitch: !this.state.keyUpSwitch })
        }
    }

    handleSelection = (selection) => {
        if (selection !== null && selection.length !== 0) {
            this.setState({ selectedWorkplace: selection })
        } else {
            this.setState({ selectedWorkplace: null })
        }
    }

    handleToolbarButtonClick = (buttonId) => {
        if  ("add" === buttonId) {
         this.setState({ linkDialogOpen: true })
        }
        else if ("view" === buttonId) {
            this.props.history.push({
                pathname: '/workplace',
                state: {
                    selection: this.state.selectedWorkplace[0].Id,
                    viewOnly: true
                }
            })
        }
    } 

    render() {
        return (
            <ViewContainer title="">
                <SearchView headCells={headCells}
                            dataUrl={!utils.isNull(this.props.dataUrl) ? this.props.dataUrl : "api/sims/workplace/getsearch"}
                            entityViewPath='/workplace'
                            model={this.state.model}
                            title='Workplace' 
                            toolbarConfig={this.toolbarConfig}
                            searchParameters={this.searchParameters}
                            filterParameters={filterParameters}
                            onLookupValueChange={this.props.onLookupValueChange}
                            descriptionProp="CompanyName"
                            mode={this.props.mode}
                            history={this.props.history}
                            hasButtonClickHandler={true}
                            buttonClickHandler={this.handleToolbarButtonClick}
                            keyUpSwitch={this.state.keyUpSwitch} deleteUrl={"api/sims/workplace/removeworkplace"} useDeletePost={true}
                            promptTitle={"Remove Workplace"} promptContent={"Are you sure you want to remove this workplace?"}
                            setSelection={(selection) => { this.handleSelection(selection) }}
            >
                    <WorkplaceSearchForm data={this.state.model} onKeyUp={(e) => { this.onkeyup(e) }}
                        valueChangeHandler={(values) => {
                            if (JSON.stringify(this.state.model) !== JSON.stringify(values)) {
                                this.setState({ model: values });
                            }
                        }} /> 
                </SearchView>
            </ViewContainer>

        );
    }
}


export default withRouter(withMenuPermission(WorkplaceSearch));

